<template>
    <div class="adminUserList">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb title="Liste des Types d'utilisateurs" :breadcumb-data="breadcumbData">
                    <b-btn v-bind:to="'/dashboard/administration/usertype/add/'" class="mt-3 mb-3" variant="primary" style="float:right">
                        Ajouter un type d'utilsateur
                    </b-btn>
                </Breadcumb>
            </div>
        </div>
        <b-card no-body class="cardcontainer">
            <b-card-body>
                <b-table
                        v-if="userTypesData"
                        :items="userTypesData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
                    
                    <template slot="Label" slot-scope="data">
                        <span>{{data.item.label }}</span>
                    </template>
                    <template slot="Label Anglais" slot-scope="data">
                        <span>{{data.item.label_en }}</span>
                    </template>
                    <template slot="Slug" slot-scope="data">
                        <span>{{data.item.slug }}</span>
                    </template>
                    <template slot="Position" slot-scope="data">
                        <span>{{data.item.position }}</span>
                    </template>
                    <template slot="Actions" slot-scope="data">
                        <b-btn v-bind:to="'/dashboard/administration/usertype/' + data.item.id" variant="default btn-xs icon-btn md-btn-flat"
                               v-b-tooltip.hover title="Profil"><i
                                class="ion ion-md-create"></i></b-btn>
                        </b-btn>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
        <b-card no-body class="mt-3 p-3">
            <table class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th>Services</th>
                    <th v-for="service in services">{{service.name}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user_type in userTypesData">
                    <td>{{ user_type.label }}</td>
                    <template v-for="service in services">
                        <td>
                            <span v-if="user_type.services.includes(service.slug)"><i
                                    class="ion ion-md-checkmark badge-success p-2"></i></span>
                            <span v-else><i
                                    class="ion ion-md-close badge-danger p-2"></i></span>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </b-card>
    </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<script>
    import {
        ADMIN_GET_USERS_REQUEST,
        ADMIN_DELETE_USER_REQUEST,
        ADMIN_GET_USERTYPES_REQUEST
    } from '../../_store/administration/user/actiontypes';
    import Breadcumb from '../../components/breadcumb';
    import { mapState } from 'vuex';
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue'

    export default {
        name: 'adminUserList',
        components: {Breadcumb, SweetModal, SweetModalTab},
        computed: mapState({ usersData: state => state.admin_user.users }),
        mounted() {
            this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
                .then(response => {
                    this.userTypesData = response.data.usertypes;
                });
        },
        methods: {
        },
        data() {
            return {
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des types d\'utilisateur', active: true },
                ],
                dataUrl: 'json/pages_users_list.json',
                searchKeys: [],
                services: [
                    {slug: 'documentation', name: 'Espace Documentaire'},
                    {slug: 'companies', name: 'Structure Organisationnelle'},
                    {slug: 'report_deposit', name: 'Dépot de rapport'},
                    {slug: 'report', name: 'Consultation rapport'},
                    {slug: 'softconcept', name: 'SoftConcept'},
                    {slug: 'survey', name: 'Création d\'enquête'},
                    {slug: 'provider', name: 'Prestataire'},
                    {slug: 'user', name: 'Utilisateur'},
                    {slug: 'reporting', name: 'Reporting'},
                    {slug: 'languages', name: 'Multilingue'},
                    {slug: 'roadmap', name: 'Plan d\'actions'}
                ],
                sortBy: 'id',
                sortDesc: false,
                perPage: 10,
                deleteId: false,
                lastname: null,
                firstname: null,
                email: null,
                userTypesData: [],
                company: null,
                user_type: null,
                fields: [
                    {
                        key: 'Label',
                        sortable: false,
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'Label Anglais',
                        sortable: false,
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'Slug',
                        sortable: false,
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'Position',
                        sortable: false,
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'Actions',
                        sortable: false,
                        tdClass: 'align-middle'
                    }
                ],
            };
        },
        layout(context) {
            return 'layout';
        },
    };
</script>
